import { useState } from "react";

type CallbackFunction = ((...args: any[]) => Promise<any> | void) | undefined;

export const useButtonDebounce = (delay = 1000) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const debounce = async (callback: CallbackFunction) => {
    if (isDisabled || !callback) return;

    setIsDisabled(true);

    try {
      await callback();
    } finally {
      setTimeout(() => {
        setIsDisabled(false);
      }, delay);
    }
  };

  return { isDisabled, debounce };
};
